import { Box, Typography } from "@mui/material";
import { TableColumn, types, Badge } from "@vilocnv/allsetra-core";
import StatusDropdownCell from "components/common/StatusDropdownCell/StatusDropdownCell";
import ObjectLinkCell from "components/common/ObjectLinkCell/ObjectLinkCell";
import DriverLinkCell from "components/common/DriverLinkCell/DriverLinkCell";
import { CarIcon, PathMileageIcon } from "assets/icons";
import { formatMileage } from "app/data/helpers/commonHelpers";

//
// TABLE HEADERS
//
export const ALL_MILEAGE_DEVIATIONS_TABLE_COLUMNS = (
  roles: any[],
  translator: any
) => {
  const tableColumns: TableColumn<any>[] = [
    {
      name: translator("tableHeading.driverName", {
        ns: "tableHeadingsTranslation"
      }),
      selector: (row: any) => (
        <DriverLinkCell driverName={row.userName || "-"} />
      ),
      sortable: false,
      sortField: "userName",
      minWidth: "180px",
      wrap: true
    },
    {
      name: translator("tableHeading.object", {
        ns: "tableHeadingsTranslation"
      }),
      selector: (row: any) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <CarIcon />
          <ObjectLinkCell
            objectName={row.objectName}
            objectUniqueId={row.objectUniqueId || row.uniqueId}
          />
        </Box>
      ),
      sortable: false,
      sortField: "objectName",
      minWidth: "280px",
      wrap: true
    },
    {
      name: translator("tableHeading.submittedDate", {
        ns: "tableHeadingsTranslation"
      }),
      selector: (row: any) => {
        if (!row.recordedDate) return "-";
        const date = new Date(row.recordedDate);
        const day = date.getDate().toString().padStart(2, "0");
        const month = date.toLocaleDateString("en-GB", { month: "short" });
        const year = date.getFullYear();
        const result = `${day}-${month}-${year}`;
        return (
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "400",
              color: "#1D1F2B",
              pointerEvents: "none"
            }}
          >
            {result}
          </Typography>
        );
      },
      sortable: true,
      sortField: "recordedDate",
      minWidth: "160px"
    },
    {
      name: translator("tableHeading.submittedMileage", {
        ns: "tableHeadingsTranslation"
      }),
      selector: (row: any) => {
        const mileage = row.recordedMileage || 0;
        const formattedMileage = formatMileage(mileage);

        return (
          <Badge colorScheme={row.recordedMileage ? "grey" : "error"}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                color: "#323946!important"
              }}
            >
              <PathMileageIcon /> {formattedMileage} km
            </Box>
          </Badge>
        );
      },
      sortable: false,
      sortField: "recordedMileage",
      minWidth: "180px"
    },
    {
      name: translator("tableHeading.systemMileage", {
        ns: "tableHeadingsTranslation"
      }),
      selector: (row: any) => {
        const mileage = row.systemMileage || 0;
        const formattedMileage = formatMileage(mileage);

        return (
          <Badge colorScheme={row.systemMileage ? "grey" : "error"}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                color: "#323946!important"
              }}
            >
              <PathMileageIcon /> {formattedMileage} km
            </Box>
          </Badge>
        );
      },
      sortable: false,
      sortField: "systemMileage",
      minWidth: "180px"
    },
    {
      name:
        translator("tableHeading.deviation", {
          ns: "tableHeadingsTranslation"
        }) + " %",
      selector: (row: any) => {
        const deviation = row.percentageDifference || 0;
        const formattedDeviation =
          typeof deviation === "number"
            ? deviation.toFixed(2)
            : parseFloat(deviation).toFixed(2);

        return (
          <Badge colorScheme={row.percentageDifference ? "purple" : "error"}>
            {formattedDeviation}
          </Badge>
        );
      },
      sortable: false,
      sortField: "percentageDifference",
      minWidth: "100px"
    },
    {
      name: translator("tableHeading.status", {
        ns: "tableHeadingsTranslation"
      }),
      selector: (row: any) => (
        <StatusDropdownCell currentStatus={row.status} rowData={row} />
      ),
      sortable: false,
      sortField: "status",
      minWidth: "120px"
    }
  ];

  return tableColumns;
};

const roleColorScheme: any = {
  User: "success",
  Driver: "error",
  Manager: "success",
  Admin: "info",
  "View Only": "info"
};

export const callAlarmPriorities: any[] = Array.from(
  { length: 9 },
  (_, ind) => ({
    id: ind + 1,
    name: ind + 1
  })
);
